import React, { ImgHTMLAttributes } from 'react';
import './Icon.css';

export interface IIconProps extends ImgHTMLAttributes<any> {
	/** Sets the container size of the icon being rendered. */
	size?: 'utility' | 'badge' | 'spot';
	customSize?: number;
	/** A boolean that determines a highlight that surrounds the icon. This only shows with the `badge` and `spot` icons. */
	background?: boolean;
}

const sizeClasses = {
	utility: 'Icon__utility w-6 h-6 min-w-6',
	badge: 'Icon__badge w-16 h-16 min-w-16',
	spot: 'Icon__spot w-32 h-32 min-w-32',
};

const Icon = ({
	size = 'badge',
	alt = 'Icon',
	customSize,
	background = false,
	className = '',
	...rest
}: IIconProps) => {
	const image = (
		<img
			alt={alt}
			className={`Icon ${className} ${customSize ? 'Icon__custom' : sizeClasses[size]}`}
			width={customSize || undefined}
			height={customSize || undefined}
			{...rest}
		/>
	);
	if (background && size !== 'utility') {
		return (
			<div
				className={`aspect-square Icon__background ${size === 'badge' ? 'w-16 h-16 Icon__background--badge' : 'w-32 h-32'
					}`}
			>
				{image}
			</div>
		);
	}
	return <>{image}</>;
};

export default Icon;
